import React from "react";
import { DataGrid } from '@mui/x-data-grid';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import CustomToolbar from '../Share/Table/CustomToolbar';
import ConfirmDialog from '../Share/ConfirmDialog';
import CreateVehicle from './CreateVehicle';
import EditVehicle from './EditVehicle';
import { addDialogVehicle, editDialogVehicle, deleteVehicle } from "../../actions/vehicleAction";
import i18next from '../../language/i18n';
import DeleteButton from '../Share/Button/DeleteButton';
import { dateFormat } from '../Share/Table/DateFormat';


class TableVehicle extends React.Component {
  constructor(props) {
    super(props);
    this.state = { IsOpenConfirmDialog: false, ID: null }
  }
  componentDidMount = () => {
  }

  partnerName = (props) => {
    return this.props.partners.find(el => el.value === props.row.partnerID)?.text;
  }
  columns = () => {
    return ([
    {
      field: 'PartnerID',
      headerName: i18next.t('Partner'),
      width: 160,
      valueGetter: this.partnerName,
      sortComparator: (v1, v2, cellParams1, cellParams2) =>
        this.partnerName(cellParams1).localeCompare(this.partnerName(cellParams2))
    },
    { field: 'description', headerName: i18next.t('Description'), minWidth: 150, flex: 1 },
    { field: 'brand', headerName: i18next.t('Brand'), minWidth: 150, flex: 1 },
    { field: 'vehicleModel', headerName: i18next.t('VehicleModel'), minWidth: 150, flex: 1 },
    { field: 'chassisNumber', headerName: i18next.t('ChassisNumber'), minWidth: 150, flex: 1 },
    { field: 'typeOfVehicle', headerName: i18next.t('TypeOfVehicle'), minWidth: 150, flex: 1 },
    // { field: 'volume', headerName: i18next.t('Volume'), minWidth: 150, flex: 1 },
    // { field: 'powerKW', headerName: i18next.t('PowerKW'), minWidth: 150, flex: 1 },
    // { field: 'carryingCapacityKg', headerName: i18next.t('CarryingCapacityKg'), minWidth: 150, flex: 1 },
    // { field: 'allowedMassKg', headerName: i18next.t('AllowedMassKg'), minWidth: 150, flex: 1 },
     { field: 'estimatedValue', headerName: i18next.t('EstimatedValue'), minWidth: 150, flex: 1 },
    // { field: 'registrationNumber', headerName: i18next.t('RegistrationNumber'), minWidth: 150, flex: 1 },
    //{ field: 'registrationExpiresOn', headerName: i18next.t('RegistrationExpiresOn'), minWidth: 150, flex: 1, valueGetter: dateFormat },
    { field: 'titleCertificateNo', headerName: i18next.t('TitleCertificateNo'), minWidth: 150, flex: 1 },
    { field: 'valid', headerName: i18next.t('Valid'), minWidth: 150, flex: 1, type: 'boolean' },

    {
      field: 'edit',
      headerName: ' ',
      hide: this.props.disabled,
      renderCell: (params) => (
        <strong>
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{ marginLeft: 16 }}
            onClick={() => this.edit(params)}
          >
            {i18next.t('Edit')}
          </Button>
        </strong>
      ),
    },
    {
      field: 'delete',
      headerName: ' ',
      hide: this.props.disabled,
      renderCell: (params) => (
        <strong>
          <DeleteButton
            onClick={() => this.delete(params)}
          ></DeleteButton>
        </strong>
      )
    }
  ])}
  create = () => {
    this.props.addDialogVehicle();
  }
  edit = (params) => {
    this.props.editDialogVehicle(params.row);
  }
  delete = (params) => {
    this.setState({ IsOpenConfirmDialog: true, ID: params.row.id });
  }
  render() {
    return (
      <div style={{ height: 400, width: '100%' }}>
        <DataGrid
          rows={this.props.vehicles}
          columns={this.columns()}
          components={{
            Toolbar: CustomToolbar
          }}
          componentsProps={{ toolbar: { createNew: this.props.disabled ? null : this.create } }}
          checkboxSelection
          disableSelectionOnClick
        />
        <CreateVehicle></CreateVehicle>
        <EditVehicle></EditVehicle>
        <ConfirmDialog
          IsOpen={this.state.IsOpenConfirmDialog}
          close={() => this.setState({ IsOpenConfirmDialog: false, ID: null })}
          confirm={() => {
            this.props.deleteVehicle(this.state.ID);
            this.setState({ IsOpenConfirmDialog: false, ID: null });
          }}
          message={'Da li ste sigurni da želite da obrišete ovaj unos?'}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    vehicles: Object.values(state.vehicles),
    partners: Object.values(state.partnersSelectBox)
  };
}

export default connect(mapStateToProps, { addDialogVehicle, editDialogVehicle, deleteVehicle })(TableVehicle);